const primary = '#0486FF'
const primary100 = 'rgba(0, 116, 168, 0.1)'
const secondary = '#e6edf1'
const info = '#5E9CE5'
const darkGrey = '#4a4a4a'
const darkGrey500 = 'rgba(74, 74, 74, 0.5)'
const whisper = '#e4e4e4'
const grey = '#878787'
const lightBlue = '#d1e0e7'
const silverGrey = '#c0c0c0'
const light = '#fff'
const beige = '#fff1b8'
const inputColor = 'rgba(0, 0, 0, 0.85)'
const gray88 = '#e0e0e0'
const primaryYellow = '#FFCC2B'
const primaryRed = '#E17567'
const requiredColor = '#FFCC2B'

const commonInputStyle = {
  bg: '#5C636580',
  disabledBg: '#5C636580',
  disabledColor: '#8E8E8E',
  placeholderColor: '#8E8E8E',
  color: '#fff',
  borderColor: '#8E8E8E80',
  hoverAndFocusBorderColor: primary,
  clearIconFill: '#fff',
}

/**
 * @return { [key: string]: any}
 */
const theme = {
  blue100: '#e7f2fd',
  blue150: 'rgba(183, 220, 255, 0.15)',
  blue200: 'rgba(183, 220, 255, 0.2)',
  blue300: 'rgba(183, 220, 255, 0.3)', // b7dcff
  blue600: 'rgba(183, 220, 255, 0.6)',
  blue700: '#b7dcff',
  cyan: '#0ab1c1',
  blue: '#5E9CE5',
  danger: '#d74c4c',
  dark: '#222',
  dark100: 'rgba(0, 0, 0, 0.1)',
  dark300: 'rgba(0, 0, 0, 0.3)',
  dark500: 'rgba(0, 0, 0, 0.5)',
  darkGrey: darkGrey,
  grey,
  grey700: 'rgba(74, 74, 74, 0.7)',
  greyF9: '#f9f9f9',
  silverGrey,
  info: info, // (16, 94, 166)
  info200: 'rgba(16, 94, 166, 0.2)',
  info500: 'rgba(16, 94, 166, 0.5)',
  info900: '#4098ef',
  lightDark: '#333',
  lightGrey: '#d8d8d8',
  lightPink: '#ffeaea',
  light: light,
  primary: primary,
  red100: '#ffdad6',
  red200: '#e17567',
  red500: 'rgba(243, 76, 57, 0.5)',
  red: 'rgb(243, 76, 57)',
  crimson: '#ce2512',
  secondary,
  warning: primary,
  yellow200: '#ffcc2b',
  yellow100: beige,
  yellow: '#ffc247',
  primaryYellow: primaryYellow,
  primaryRed: primaryRed,
  requiredColor: requiredColor,
  btn: {
    text: '#fff',
    bg: primary,
    bgHover: '#0C62B2',
    ghostColor: primary,
    ghostHover: 'rgba(15, 140, 255, 0.3)',
    linkHover: '#084EF8',
    linkColor: '#51BCFF',
    info: info,
    infoHover: 'rgba(94, 156, 229, 0.5)',
    danger: '#E17567',
    dangerHover: '#C04B3B',
    warning: '#b68116',
    warningHover: '#9d6f12',
  },
  logoText: '#fff',
  gray88,
  whisper: whisper,
  reporttable: {
    headBg: grey,
    head: '#fff',
    bodyColor: '#878787',
    bodyOddBg: '#fff',
    bodyEvenBg: '#f2f6f8',
    hoverBg: '#fff5d5',
    hoverFirstColumnBg: '#9f9575',
  },
  slider: '#c0973f',
  sliderBg: '#c0973f',
  block: {
    text: grey,
    section: darkGrey,
    title: darkGrey,
    content: '#1B1D1D',
    borderBottom: info,
    borderRight: 'transparent',
  },
  sidemenu: primary,
  calendarIcon: grey,
  searchIcon: primary,
  schedule: {
    searchBtn: darkGrey,
    searchBtnBg: primary,
    searchBtnIcon: darkGrey,
    text: info,
    checkboxDisable: darkGrey,
  },
  font: {
    primary,
    secondary: grey,
  },
  icon: {
    primary: '#fff',
    primaryHover: darkGrey,
    secondary: '#fff',
  },
  lightBlue,
  darkGrey500,
  map: {
    rectangleOptions: {
      fillColor: 'rgba(255, 207, 110, 0.3)',
      strokeColor: '#b68116',
      strokeWeight: 2,
    },
  },
  tooltip: {
    color: darkGrey,
    bg: beige,
  },
  message: {
    color: darkGrey,
    bg: beige,
    fontSize: '16px',
    fontWeight: 500,
  },
  gamboge: '#b68116',
  menuInlineTooltip: {
    bg: '#fff',
    color: grey,
    active: primary,
  },
  group: {
    active: { bg: '#dff5ff' },
  },
  infowindow: {
    color: darkGrey,
    border: primary,
    borderRadius: '4px',
    titleBg: primary,
    titleColor: light,
    columnBg: '#cce4ee',
    width: '143px',
    height: '136px',
  },
  treeview: {
    icon: '#fff',
    iconHover: darkGrey,
    mapIcon: '#7fbad4',
    color: '#fff',
  },

  imageuploader: {
    bg: '#424546',
    boderColor: 'transparent',
    iconColor: '#fff',
  },
  table: {
    bg: 'transparent',
    head: {
      color: '#fff',
      simpleModeColor: '#A1DDFF',
      bg: 'transparent',
      separatorColor: '#FFFFFF',
      simpleModeSeparatorColor: 'rgba(255, 255, 255, 0.2)',
    },
    cell: {
      color: '#fff',
      oddBg: 'transparent',
      evenBg: '#FFFFFF08',
      bgHover: '#FFCC2B50',
      border: `1px solid #4a4a4a`,
      selectedBg: beige,
    },
    borderSpacing: '0px 0px',
  },
  // Dashboard Table
  colorfulTable: {
    head: {
      color: '#0074a8',
      bg: '#dff5ff',
    },
    cell: {
      evenBg: '#e6edf173',
      oddBg: '#fff',
      color: '#000000d9',
      bg: '#fff',
      hoverBg: 'rgba(230, 237, 241, 0.9)',
      highlightColor: '#000000d9',
    },
  },
  pagination: {
    borderColor: '#fff',
    color: '#fff',
    simpleModeColor: '#A1DDFF',
    bg: 'transparent',
    hover: {
      borderColor: '#fff',
      color: '#005A82',
      bg: '#FFFFFF',
    },
    active: {
      borderColor: '#fff',
      color: '#005A82',
      bg: '#FFFFFF',
    },
  },
  checkbox: {
    border: '#8E8E8E80',
    bg: '#5C636580',
    checkedBg: '#20E4FF1A',
    checkedBorderColor: '#20E4FF',
    checkedColor: '#20E4FF',
  },
  input: {
    bg: '#5C636580',
    disabledBg: commonInputStyle.disabledBg,
    disabledColor: commonInputStyle.disabledColor,
    placeholderColor: '#8E8E8E',
    color: '#fff',
    borderColor: '#8E8E8E80',
    hoverAndFocusBorderColor: primary,
    clearIconFill: '#fff',
  },
  datePicker: {
    bg: commonInputStyle.bg,
    disabledBg: commonInputStyle.disabledBg,
    disabledColor: commonInputStyle.disabledColor,
    placeholderColor: commonInputStyle.placeholderColor,
    color: commonInputStyle.color,
    borderColor: commonInputStyle.borderColor,
    hoverAndFocusBorderColor: primary,
    clearIconFill: commonInputStyle.clearIconFill,
    calendarIconFill: commonInputStyle.clearIconFill,
    rangeActiveBarBg: '#1890ff',
    panel: {
      bg: '#272727',
      borderColor: 'rgba(255, 255, 255, 0.2)',
      color: '#FFFFFF',
      unselectColor: 'rgba(255, 255, 255, 0.2)',
      todayColor: '#FFFFFF',
      selectedBg: '#00A0E9',
      selectedColor: '#fff',
      hoverBg: '#00A0E9',
      hoverColor: '#fff',
      prevAndNextBtnColor: '#FFFFFF',
      prevAndNextBtnHoverColor: '#FFFFFF',
      inRangeBg: 'rgba(24, 144, 255, 0.4)',
      inRangeColor: '#fff',
      inRangeBorderColor: 'rgba(24, 144, 255, 0.4)',
      inRangeHoverBg: 'rgba(24, 144, 255, 0.4)',
    },
  },
  select: {
    bg: commonInputStyle.bg,
    disabledBg: commonInputStyle.disabledBg,
    disabledColor: commonInputStyle.disabledColor,
    placeholderColor: commonInputStyle.placeholderColor,
    color: commonInputStyle.color,
    tagColor: '#4a4a4a',
    borderColor: commonInputStyle.borderColor,
    hoverAndFocusBorderColor: primary,
    clearIconFill: commonInputStyle.clearIconFill,
    arrowDownIconFill: commonInputStyle.clearIconFill,
    dropdown: {
      bg: '#272727',
      color: '#fff',
      hoverBg: 'red',
      hoverColor: 'red',
      selectedBg: '#1890FF',
      selectedColor: '#fff',
      item: {
        bg: '#272727',
        color: '#fff',
        fontWeight: 'normal',
        hoverBg: '#003248',
        hoverColor: '#fff',
        selectedFontWeight: '600',
        selectedBg: '#1890FF',
        selectedColor: '#fff',
      },
    },
  },
  dropdown: {
    bg: '#272727',
    color: '#FFFFFF',
    hoverBg: '#1890FF',
    hoverColor: '#fff',
  },
  layout: {
    bg: '#272727',
    borderTop: primary,
    content: {
      bg: '#272727',
    },
  },
  menu: {
    bg: '#1B1D1D',
    color: 'rgba(255, 255, 255, 0.7)',
    hoverColor: '#fff',
    hoverBg: '#0486FF',
    activeBg: '#272727',
    activeColor: '#41A4FF',
    sub: {
      bg: '#1B1D1D',
      activeBg: '#0486FF',
      activeColor: '#fff',
    },
  },
  pageContent: {
    bg: 'transparent',
    borderRadius: '8px 0 0 0',
    margin: '0 0 0 24px',
  },
  form: {
    evenRowBg: '#272727',
    oddRowBg: '#FFFFFF08',
    labelColor: '#FFFFFF',
    valueColor: darkGrey,
    border: '1px solid #4a4a4a',
    modalLabelColor: '#A1DDFF',
  },
  tabs: {
    color: 'rgba(255, 255, 255, 0.3)',
    hoverColor: '#41A4FF',
    activeColor: '#0486FF',
    border: `1px solid #0486FF`,
  },
  modal: {
    bg: '#272727',
    mask: 'rgba(0, 44, 86, 0.7)',
    maskDarken: 'rgba(0, 44, 86, 0.9)',
    border: info,
    color: '#fff',
    footerBorderTop: '0px',
  },
  widget: {
    header: {
      bg: '#fff',
      color: darkGrey,
      borderBottom: `1px solid rgba(0, 0, 0, 0.1)`,
    },
    content: {
      bg: '#fff',
      titleColor: darkGrey,
      titleDescColor: '#a1ddff',
    },
  },
  breadcrumb: {
    focusColor: '#41A4FF',
    color: 'rgba(255, 255, 255, 0.5)',
  },
  tree: {
    childrenTreeBg: 'rgba(92, 99, 101, 0.5)',
    childrenTreeBoxShadow:
      'inset 0px 7px 6px -6px rgba(0, 0, 0, 0.1), inset 0px -7px 6px -6px rgba(0, 0, 0, 0.1)',
    rootColor: '#FFCC2B',
    normalColor: '#fff',
    activeColor: '#fff',
    activeBg: 'rgba(255, 204, 43, 0.2)',
    hoverBg: '#0486FF',
    rootHoverColor: '#FFCC2B',
    normalHoverColor: '#fff',
    borderLeft: `3px solid ${primary}`,
    borderBottomColor: 'rgba(255, 255, 255, 0.1)',
  },
  statusTag: {
    alarmBg: '#e17567',
    repairBg: '#767575',
    failBg: '#767575',
    normalBg: '#84cf35',
  },
  report: {
    color: darkGrey,
    tooltip: {
      bg: beige,
      borderColor: undefined,
    },
    gridLineColor: '#e6e6e6',
    xAxisLineColor: '#e6e6e6',
  },
  text: {
    primary,
    secondary: '#A1DDFF',
    normal: '#fff',
    info: '#FFCC2B',
    prompt: 'rgba(255, 255, 255, 0.3)',
  },
  radio: {
    color: '#fff',
    bg: '#005A82',
    bgChecked: '#fff',
    borderColor: '#5C97B2',
  },

  n: {
    blue100: '#e6edf1',
    blue150: '#dff5ff',
    blue250: '#b7d6e4',
    blue400: '#5e9ce5',
    blue500: '#0074a8',
    blue600: '#0e2e3c',
    lightBlue400: '#00c5ff',
    gray50: '#f8f8f8',
    gray100: '#e4e4e4',
    gray200: '#c0c0c0',
    gray250: '#767575',
    gray300: '#878787',
    geay350: '#96a6ad',
    gray400: '#4a4a4a',
    gray500: '#313131',
    yellow50: '#fffcf1',
    yellow100: '#fff1b8',
    yellow400: '#ffcc2b',
    green300: '#6cc26c',
    green400: '#60bb00',
    green500: '#00b900',
    pink400: '#e17567',
    orange400: '#ec9947',
    purple600: '#771c70',
    success: '#6dd400',
    danger: '#ff342b',
    warning: '#ff9408',
    secondary: '#b7b7b7',
    map: {
      rectangleOptions: {
        fillColor: 'rgba(255, 204, 43, 0.2)',
        strokeColor: '#ffcc2b',
        strokeWeight: 4,
      },
    },
  },
}

module.exports = theme
